import Dictionary from './../../utils/dictionary';
export default class PackageStore {
    static createOrUpdate(pack) {
        this.stores.set(pack.guid, {});
    }
    static get(guid) {
        return this.stores.get(guid);
    }
    static contain(guid) {
        return this.stores.has(guid);
    }
    static remove(packGuid) {
        this.stores.delete(packGuid);
    }
}
PackageStore.stores = new Dictionary();
//# sourceMappingURL=packageStore.js.map